import { MdDelete, MdEdit } from "react-icons/md";

import Modal from "../../../../components/Modal";
import UpdateOption from "./UpdateOption";
import ConfirmDelete from "../../../../components/ConfirmDelete";
import { useDeleteQuizOption } from "../hooks/useDeleteQuizOption";
import { useParams } from "react-router-dom";
import usePermission from "../../../../hooks/usePermission";

function Choice({ choice, optionNum, type = "view" }) {
    const { can } = usePermission();

    const { option, isCorrect } = choice.attributes;
    const { id } = choice;

    const { courseId, lectureId, itemId, questionId } = useParams();

    const { deleteQuizOption, isDeleting } = useDeleteQuizOption();

    return (
        <div
            className={`flex items-center justify-between w-full p-5 text-blue-color-primary  border border-gray-200 rounded-lg shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px] ${
                isCorrect ? "bg-green-600 text-white" : "bg-white-color"
            }`}
        >
            <div className="flex">
                <span className="flex items-center justify-center mx-2 leading-5 border-2 rounded-full w-7 h-7 text-blue-color-primary bg-primary-color-light">
                    {optionNum + 1}
                </span>
                {option}
            </div>
            {type === "edit" && (
                <div className="flex justify-between gap-4">
                    <Modal>
                        {/* Modal For Updating */}
                        {can(
                            "update:course:lecture:quiz:quiestion:options"
                        ) && (
                            <>
                                <Modal.Open opens="edit">
                                    <button>
                                        <MdEdit className="text-lg text-blue-color-primary" />
                                    </button>
                                </Modal.Open>
                                <Modal.Window name="edit">
                                    <UpdateOption
                                        option={option}
                                        isCorrect={isCorrect}
                                        optionId={id}
                                    />
                                </Modal.Window>
                            </>
                        )}

                        {/* Modal For Deleting Option */}

                        {can(
                            "delete:course:lecture:quiz:quiestion:options"
                        ) && (
                            <>
                                <Modal.Open opens="delete">
                                    <button>
                                        <MdDelete className="text-lg text-red-color-primary" />
                                    </button>
                                </Modal.Open>
                                <Modal.Window name="delete">
                                    <ConfirmDelete
                                        resourceName={option}
                                        disabled={isDeleting}
                                        onConfirm={() =>
                                            deleteQuizOption({
                                                courseId,
                                                lectureId,
                                                itemId,
                                                questionId,
                                                optionId: id,
                                            })
                                        }
                                    />
                                </Modal.Window>
                            </>
                        )}
                    </Modal>
                </div>
            )}
        </div>
    );
}

export default Choice;
